import React from "react";

export const StoryContext = React.createContext({
    setImage: null,
    doDeleteConfirm: null,
});